<template>
  <section class="result-area">
    <div v-if="results.length > 0" class="container container-sm">
      <div class="row">
        <div class="col-12 col-lg-12">
          <div class="common-heading">
            <h4>
              Results
              <span v-if="formattedTimeTaken != undefined"
                >{{ getNumResults }} results in ____________
                {{ formattedTimeTaken }} seconds</span
              >
            </h4>
          </div>
        </div>
        <div
          class="col-12 col-lg-12"
          v-for="provider in sortedResults"
          v-if="!isLoading"
        >
          <div class="each-result clickable">
            <investor-list-item :provider="provider" />
          </div>
        </div>
        <div
          v-if="isMoreResults"
          class="col-lg-12 mb-lg-5 pb-lg-5 pt-5 text-center"
        >
          <infinite-loading
            @infinite="loadMore"
            spinner="spiral"
          ></infinite-loading>
          <div v-if="!loadingMore" class="arrow-down">
            <p>
              <a
                ><img
                  :src="require('../../assets/images/arrow.png')"
                  class="mx-auto d-table"
                  alt=""
              /></a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="isLoading" class="container container-sm">
      <div class="row">
        <div class="col-12 col-lg-12">
          <div class="common-heading">
            <div class="container container-xs" style="height: 300px;">
              <h4>
                Loading...
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="!isFirstSearch && !isLoading"
      class="container container-sm"
    >
      <div class="row">
        <div class="col-12 col-lg-12">
          <div class="common-heading">
            <h4>
              No Results
              <span> Please broaden your search parameters.</span>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="isFirstSearch" class="container container-sm"></div>
  </section>
</template>

<script>
import InvestorListItem from "./InvestorListItem.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import InfiniteLoading from "vue-infinite-loading";

export default {
  name: "DirectoryResults",
  components: {
    "investor-list-item": InvestorListItem,
    "infinite-loading": InfiniteLoading
  },
  data: function() {
    return {
      loadingMore: false
    };
  },
  watch: {
    results(newValue, oldValue) {
      if (newValue.length > 0 && oldValue.length == 0) {
        this.setIsLoading(false);
      } else if (
        newValue.length == 0 &&
        oldValue.length == 0 &&
        !this.isFirstSearch
      ) {
        this.setIsLoading(false);
      }
    }
  },
  computed: {
    ...mapGetters([
      "results",
      "currentResults",
      "isFirstSearch",
      "fundingNeed",
      "timeTaken",
      "noResults",
      "isLoading",
      "getNumResults"
    ]),
    sortedResults: function() {
      var results = this.providersOrderdByFundingNeed();
      return results.slice(0, this.noResults);
    },
    isMoreResults() {
      return this.noResults < this.results.length;
    },
    formattedTimeTaken() {
      return (this.timeTaken / 1000).toFixed(4);
    }
  },
  methods: {
    ...mapMutations([
      "appendResults",
      "setPage",
      "setFirstSearch",
      "setResults",
      "setIsLoading",
      "addMoreResults",
      "resetNumberResults"
    ]),
    loadMore: function($state) {
      this.loadingMore = true;
      setTimeout(() => {
        this.addMoreResults(10);
        if (!this.isMoreResults) {
          $state.complete();
        }
        this.loadingMore = false;
        $state.loaded();
      }, 1000);
    },
    getMaxAndMin(provider) {
      var minStat;
      var maxStat;
      if (provider.hasOwnProperty("min_investment")) {
        minStat = { value: provider.max_investment };
      } else {
        minStat = provider.provider_stats.find(stat => {
          return stat.stat.code == "minimum_investment";
        });
      }

      if (provider.hasOwnProperty("max_investment")) {
        maxStat = { value: provider.min_investment };
      } else {
        var maxStat = provider.provider_stats.find(stat => {
          return stat.stat.code == "maximum_investment";
        });
      }
      return minStat, maxStat;
    },
    fundingNeedOrder(providerA, providerB) {
      var minAstat,
        maxAstat = this.getMaxAndMin(providerA);
      var minBstat,
        maxBstat = this.getMaxAndMin(providerB);
      if (minAstat && maxAstat && !(minBstat && maxBstat)) {
        return -1;
      }
      if (minBstat && maxBstat && !(minAstat && maxAstat)) {
        return 1;
      }
      if (!(minBstat && maxBstat) && !(minAstat && maxAstat)) {
        var idA = providerA.hasOwnProperty("id")
          ? providerA.id
          : providerA.provider_id;
        var idB = providerB.hasOwnProperty("id")
          ? providerB.id
          : providerB.provider_id;
        return idA > idB ? 1 : -1;
      }

      var minA = minAstat.value;
      var minB = minBstat.value;
      var maxA = maxAstat.value;
      var maxB = maxBstat.value;
      var AOverlap = false;
      var BOverlap = false;

      var mapIdToFundingNeed = {
        1: [0, 25000],
        2: [25000, 75000],
        3: [75000, 150000],
        4: [150000, 500000],
        5: [500000, 10000000000]
      };
      var fundingNeed = mapIdToFundingNeed[this.fundingNeed];

      if (fundingNeed[0] < maxA || fundingNeed[1] > minA) {
        AOverlap = true;
      }

      if (fundingNeed[0] < maxB || fundingNeed[1] > maxA) {
        BOverlap = true;
      }

      if ((AOverlap && BOverlap) || !(AOverlap && BOverlap)) {
        var idA = providerA.hasOwnProperty("id")
          ? providerA.id
          : providerA.provider_id;
        var idB = providerB.hasOwnProperty("id")
          ? providerB.id
          : providerB.provider_id;
        return idA > idB ? 1 : -1;
      } else if (AOverlap && !BOverlap) {
        return -1;
      } else if (!AOverlap && BOverlap) {
        return 1;
      }
    },
    providersOrderdByFundingNeed() {
      var that = this;
      var results = this.results;
      if (this.findingNeed != "0") {
        results.sort(function(a, b) {
          return that.fundingNeedOrder(a, b);
        }, that);
      }
      return results;
    }
  },
  created() {
    this.resetNumberResults();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/directory/DirectoryResults.vue